// extracted by mini-css-extract-plugin
export default {"boardHeader":"BoardView_boardHeader__K6Uda","materialImage":"BoardView_materialImage__BaN-f"};